<script setup lang="ts">
import type { SubmitEventPromise } from 'vuetify';

import { computed, reactive, ref, toRaw } from 'vue';

import DetailedJobAttachmentsDropZoneField from '@/components/fields/DetailedJobAttachmentsDropZoneField.vue';
import useForm from '@/composables/useForm';

export interface InitialData {
  attachments?: File[];
}

export interface ValidData {
  attachments: File[];
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [event: SubmitEventPromise | null | undefined, formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, function (event) {
  emit('submit', event, toRaw(formData) as ValidData);
});

const attachmentsLimit = 5;

const isAttachmentsLimit = computed(() => {
  return (
    // TODO
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    attachmentsLimit && (formData.attachments?.length || 0) > attachmentsLimit
  );
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.uploadingFilesDialogForm"
    data-testid="uploadingFilesDialogForm"
    @submit.prevent="handleSubmit"
  >
    <DetailedJobAttachmentsDropZoneField
      v-model="formData.attachments"
      :limit="attachmentsLimit"
      :disabled="props.loading"
      :class="$style.field"
    />
    <input
      type="submit"
      class="hidden"
      :disabled="props.loading || isAttachmentsLimit"
    />
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.uploadingFilesDialogForm {
}
  .field {
    margin-bottom: 0.5rem;
  }
</style>
